import * as React from "react";
import styled, { css } from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Alert } from "components/bootstrap";
import { ExternalLink } from "components/common";
const StyledAlert = styled(Alert)(
  () => css`
    margin-top: 0;
  `
);
const StyledOl = styled.ol(
  ({ theme }) => css`
    padding-left: 20px;

    > li {
      margin-bottom: ${theme.spacings.sm};
    }

    > li:last-child {
      margin-bottom: 0;
    }
  `
);
const AzureRepositorySetupInfo = () => {
  const productName = useProductName();
  const { t } = useTranslation("enterprise_data_tiering");
  return /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info", title: t("azure_setup.title") }, /* @__PURE__ */ React.createElement(StyledOl, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "azure_setup.create_container",
      components: {
        containerLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://learn.microsoft.com/en-us/azure/storage/blobs/storage-quickstart-blobs-portal" })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "azure_setup.add_keys",
      components: {
        keysLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://learn.microsoft.com/en-us/azure/storage/common/storage-account-keys-manage" })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "azure_setup.give_access",
      values: { productName },
      components: {
        authLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://learn.microsoft.com/en-us/azure/developer/java/sdk/authentication/credential-chains#defaultazurecredential-overview" })
      }
    }
  )), /* @__PURE__ */ React.createElement("li", null, t("azure_setup.enter_container"))));
};
export default AzureRepositorySetupInfo;
